import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const AccountManagementChildrenStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  personId: ''
};

const AccountManagementChildrenContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountManagementChildrenStateContext.Provider value={stateHook}>
      {children}
    </AccountManagementChildrenStateContext.Provider>
  );
};

export default AccountManagementChildrenContextProvider;